import { Grid, TextField } from '@mui/material'
import { RailVisitTrackAndTimingFormStore } from '@planning/pages/RailVisit/stores/RailVisitTrackAndTimingFormStore'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { RailVisitPlanningTimingFields } from './RailVisitPlanningTimingFields'
import { RailVisitPlanningTrackSelector } from './RailVisitPlanningTrackSelector'
import { RailVisitTypeSelector } from './RailVisitTypeSelector'

export interface IRailVisitTrackAndTimingSubFormProps {
  store: RailVisitTrackAndTimingFormStore
  hideTypeSelector?: boolean
}

export const RailVisitTrackAndTimingSubForm: FC<IRailVisitTrackAndTimingSubFormProps> = observer(
  ({ store, hideTypeSelector = false }) => {
    const { t } = useTranslate()

    return (
      <Grid container spacing={2}>
        <RailVisitPlanningTimingFields store={store} />

        {!hideTypeSelector && <RailVisitTypeSelector store={store} />}
        <Grid size={{ xs: 12 }}>
          <TextField
            {...store.railcarEstimate.props}
            data-cy='rail-visit-planning-railcar-estimate-field'
            fullWidth
            label={t('railcarEstimation', 'Railcars estimation')}
            variant='outlined'
            type='text'
            name={`railcarEstimate`}
          />
        </Grid>

        <RailVisitPlanningTrackSelector store={store} />
      </Grid>
    )
  },
)
